import {useState, useRef} from 'react'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import LoginForm from './LoginForm.tsx'
import {LoginPresentation} from './LoginPresentation.tsx'
import {LoginPresentationFooter} from './LoginPresentationFooter.tsx'
import {ImpersonateProps} from './Login.tsx'

const LoginTabs = (props: ImpersonateProps) => {
  const [selectedTab, setSelectedTab] = useState<string>('login');
  const isUnmounted = useRef<boolean>(false);

    const handleSelectedTab = (tab: string) => {
        if (!isUnmounted.current) {
            setSelectedTab(tab)
        }
    }

    return (
        <div className="bg-primary">
            <Tabs
                activeKey={selectedTab}
                onSelect={(k) => handleSelectedTab(k)}
                id="login-tabs"
                className="col-md-10 offset-md-1 col-xl-8 offset-xl-2 col-hd-6 offset-hd-3">
                <Tab
                    eventKey="login"
                    title={
                        <span className="d-flex align-items-center">
                            <FontAwesomeIcon
                                icon="key"
                                color="white"
                                className="mr-1"
                            />
                            S'identifier
                        </span>
                    }>
                    <LoginForm {...props} />
                </Tab>

                <Tab
                    eventKey="presentation"
                    title={
                        <span className="text-decoration-none d-flex align-items-center">
                            <FontAwesomeIcon
                                icon={['fab', 'youtube']}
                                color="white"
                                className="mr-1"
                            />
                            Présentation
                        </span>
                    }>
                    <LoginPresentation />
                    <LoginPresentationFooter />
                </Tab>
            </Tabs>
        </div>
    )
}

export default LoginTabs
